const CACHE_SECONDS = 0;

const basicDomains = {};

const networkDomains = {
  documentation: {
    url: {
      docs_detail: () => `/documentation`,
    },
  },
  dashboard: {
    url: {
      tab_list: () => `/my-dashboards`,
      tab_data: ({ identifier }) => `/my-dashboards/${identifier}`,
      today: ({}) => `/my-tasks/today`,
      restart_engine: () => `/engine-action`,
    },
  },
  notification: {
    url: {
      list: () => `/my-notifications`,
      count: () => `/my-notifications-count`,
      trigger: () => `/trigger-action`,
      update: () => `/my-notifications/update`,
    },
  },
  usergroups: {
    url: {
      grouped_reconcilers: () => `/reconcilers-overview`,
      list: () => `/my-groups`,
      detail: ({ identifier }) => `/my-groups/${identifier}`,
      groupsources: () => `/my-group-sources`,
      groupsourcedetail: ({ identifier }) => `/my-group-sources/${identifier}`,
      close_source: ({ identifier }) => `/sources/${identifier}/close`,
      closing_history: ({ identifier }) => `/sources/${identifier}/close`,
      groupsourcedetailbasics: ({ identifier }) => `/my-sources/${identifier}`,
      mark_fav: ({ identifier }) => `/my-groups/${identifier}/mark-favourite`,
      unmark_fav: ({ identifier }) =>
        `/my-groups/${identifier}/remove-favourite`,
      source_extra_infos: ({ identifier }) =>
        `/my-group-sources/${identifier}/txn-pack-info`,
      run_source_for_reconciler: ({ params: { source_id, reconciler_id } }) =>
        `/sources/${source_id}/reconcilers/${reconciler_id}/re-run`,
    },
  },
  groups: {
    // offline_first:true,
    url: {
      list: () => `/groups`,
      detail: ({ identifier }) => `/groups/${identifier}`,
      sourcegroup_list: () => `/group-sources`,
      sourcegroup_detail: ({ identifier }) => `/group-sources/${identifier}`,
      labelgroup_list: () => `/group-source-labels`,
      group_unlabelled_tags: () => `/group-unlabelled-tags`,
      labelgroup_detail: ({ identifier }) =>
        `/group-source-labels/${identifier}`,
    },
  },
  batchergroup: {
    url: {
      batcher_group_list: () => `/batcher-groups`,
      batcher_group_detail: ({ identifier }) => `/batcher-groups/${identifier}`,
      batcher_reconciler_list: () => `/batcher-reconcilers`,
      batcher_reconciler_detail: ({ identifier }) =>
        `/batcher-reconcilers/${identifier}`,
      batcher_rule_list: () => `/batcher-rules`,
      batcher_rule_detail: ({ identifier }) => `/batcher-rules/${identifier}`,
    },
  },
  failedTransaction:{
    url:{
      list:()=>`/show_un_exported_txn`
    }
  },
  cache: {
    url: {
      list: () => `/cached-data-sources`,
      detail: ({ identifier }) => `/cached-data-sources/${identifier}`,
      list_data: ({ identifier }) =>
        `/cached-data-sources/${identifier}/caches`,
      cache_data_detail: ({ params: { cache_id, data_id } }) =>
        `/cached-data-sources/${cache_id}/caches/${data_id}`,
    },
  },
  reports: {
    url: {
      report_configs: () => `/my-report-configs`,
      report_configs_detail: ({ identifier }) =>
        `/my-report-configs/${identifier}`,
      report_actions: ({ identifier }) =>
        `/my-report-configs/${identifier}/actions`,
      report_actions_detail: ({ params: { config_id, action_id } }) =>
        `/my-report-configs/${config_id}/actions/${action_id}`,
      report_plugins: () => `/report-plugins`,
      direct_report_plugins: ({ identifier }) =>
        `list/source-reports?source_name=${identifier}`,
      report_plugins_detail: ({ identifier }) =>
        `/report-plugins/${identifier}`,
      generate_report: () => `/generate-report`,
      user_list: () => `/all-users`,
      participants: ({ identifier }) =>
        `/my-report-configs/${identifier}/participants`,
      participants_detail: ({ params: { config_id, participant_id } }) =>
        `/my-report-configs/${config_id}/participants/${participant_id}`,

      inbox_list: () => `/my-reports?archived=false`,
      archived_list: () => `/my-reports?archived=true`,

      report_detail: ({ identifier }) => `/my-reports/${identifier}/view`,
      archive_report: ({ identifier }) => `/my-reports/${identifier}/archive`,
      unarchive_report: ({ identifier }) =>
        `/my-reports/${identifier}/unarchive`,
      mark_seen_report: ({ identifier }) =>
        `/my-reports/${identifier}/mark-seen`,
      download_report: ({ identifier }) => `/my-reports/${identifier}/download`,
    },
  },
  fetcher: {
    url: {
      repository_list: () => `/my-data-repositories`,
      repository_upload: ({ identifier }) =>
        `/my-data-repositories/${identifier}/upload`,
      repository_run: ({ identifier }) =>
        `/my-data-repositories/${identifier}/run`,
      repository_detail: ({ identifier }) =>
        `/my-data-repositories/${identifier}`,

      fetcher_logs: ({ params: { repository_id } }) =>
        `/repository/${repository_id}/logs`,

      fetcher_logs_responses: ({ identifier }) =>
        `/fetcher-logs/${identifier}/responses`,
      fetcher_logs_detail: ({ identifier }) => `/fetcher-logs/${identifier}`,

      fetcher_responses: ({ params: { repository_id } }) =>
        `/repository/${repository_id}/responses`,
      fetcher_responses_detail: ({ params: { repository_id, response_id } }) =>
        `/repository/${repository_id}/responses/${response_id}`,

      fetcher_responses_datatypes: ({ identifier }) =>
        `/fetcher-responses/${identifier}/data-types`,
      rerun_responses: ({ identifier }) =>
        `/fetcher-responses/${identifier}/reprocess`,
      untransfer_response: ({ identifier }) =>
        `/fetcher-responses/${identifier}/untransfer`,
      download_responses: ({ identifier }) =>
        `/fetcher-responses/${identifier}/download`,
      transaction_download: ({ identifier, params: { data_type_id } }) =>
        `/my-data-types/${data_type_id}/staging-info/files/${identifier}/csv/download-url`,
    },
  },
  activity: {
    url: {
      remove_duplicate: ({}) => `/remove-duplicate`,
      file_list: ({ identifier }) =>
        `/my-data-types/${identifier}/staging-info/files`,
      file_detail: ({ identifier, params: { file_id } }) =>
        `/my-data-types/${identifier}/staging-info/files/${file_id}`,
      file_nottransferred_transactions: ({ identifier }) =>
        `my-data-types/${identifier}/un-transferred-transactions`,
      file_reprocess: ({ params: { response_id, file_id } }) =>
        `/fetcher-responses/${response_id}/${file_id}/reprocess`,
      file_raws: ({ identifier, params: { file_id } }) =>
        `/my-data-types/${identifier}/staging-info/files/${file_id}/transactions`,
      file_highlighter: ({ identifier, params: { file_id } }) =>
        `/my-data-types/${identifier}/staging-info/files/${file_id}/rows`,
      file_download: ({ identifier, params: { file_id } }) =>
        `/my-data-types/${identifier}/staging-info/files/${file_id}/download-url`,
      packet_list: ({ identifier }) =>
        `/my-data-types/${identifier}/staging-info/packets`,

      packet_detail: ({ identifier }) =>
        `/my-data-types/staging-info/packets/${identifier}`,
      packet_delete: ({ identifier }) =>
        `/my-data-types/${identifier}/delete-packets`,
      packet_classify: ({ identifier }) =>
        `/my-data-types/${identifier}/packets/re-run`,
      packet_untransfer: ({ identifier }) =>
        `/my-data-types/staging-info/packets/${identifier}/un-transfer`,

      packet_transfer: ({ identifier }) =>
        `/my-data-types/staging-info/packets/${identifier}/transfer`,
      packet_overview: ({ identifier }) =>
        `/packets/${identifier}/aggregations`,
      source_labels: ({ identifier }) =>
        `/my-data-types/${identifier}/source-labels`,
      download_template: ({ identifier }) =>
        `/my-data-types/${identifier}/download-template`,
      upload_datatype_file: ({ identifier }) =>
        `/my-data-types/${identifier}/upload-normalized-txns`,
      upload_datatype_reversal: ({ identifier }) =>
        `/my-data-types/${identifier}/reversal-upload`,
      run_datatype: ({ identifier }) =>
        `/my-data-types/${identifier}/reconcilers/re-run`,
      reversal_config_upload: ({ identifier }) =>
        `/data_type/${identifier}/config`,
    },
  },
  usertable: {
    url: {
      list: () => `/my-tables`,
      table_data: ({ identifier }) => `/dynamic/${identifier}`,
      table_detail: ({ identifier }) => `/my-tables/${identifier}`,
      file_detail: ({ identifier }) => `dynamic/${identifier}/file`,
      table_data_detail: ({ params: { table_id, data_id } }) =>
        `/dynamic/${table_id}/${data_id}`,

      table_file_data_detail: ({ identifier }) => `/dynamic/${identifier}/file`,
    },
  },
  batching: {
    url: {
      our_aggregated: ({ identifier }) =>
        `/my-reconcilers/${identifier}/unreconciled-our-transactions?aggregated=true`,
      our_normal: ({ identifier }) =>
        `/my-reconcilers/${identifier}/unreconciled-our-transactions?aggregated=false`,
      their_aggregated: ({ identifier }) =>
        `/my-reconcilers/${identifier}/unreconciled-their-transactions?aggregated=true`,
      their_normal: ({ identifier }) =>
        `/my-reconcilers/${identifier}/unreconciled-their-transactions?aggregated=false`,
      create_batch: ({ identifier }) =>
        `/my-reconcilers/${identifier}/aggregate`,
      create_batch_v2: ({ identifier }) =>
        `/my-reconcilers/${identifier}/aggregate-v2`,
      delete_aggregated: ({ identifier }) =>
        `/my-reconcilers/${identifier}/delete-aggregate-v2`,
      recommended_batch: ({ identifier }) =>
        `/my-reconcilers/${identifier}/scored-batch-peers`,
      recommended_plugin_batch: ({ identifier }) =>
        `/my-reconcilers/${identifier}/plugin-batch-peers`,
      list_batch: ({ identifier, params: { txn_id } }) =>
        `/my-reconcilers/${identifier}/${txn_id}/batch-peers`, //params{txn_id}
      list_batch_v2: ({ identifier, params: { txn_id } }) =>
        `/my-reconcilers/${identifier}/${txn_id}/batch-peers-v2`,
      remove_from_batch: ({ identifier, params: { txn_id, peer_id } }) =>
        `/my-reconcilers/${identifier}/${txn_id}/unbatch-peer/${peer_id}`, //params{txn_id,peer_id}
      remove_from_batch_v2: ({ identifier, params: { txn_id } }) =>
        `/my-reconcilers/${identifier}/${txn_id}/unbatch-peer-v2`,
    },
  },

  reconciliation: {
    // cache_for_seconds:5*60,
    url: {
      list_reconcilers: () => `/my-reconcilers`,
      detail_reconcilers: ({ identifier }) => `/my-reconcilers/${identifier}`,
      reconcilers_mark_fav: ({ identifier }) =>
        `/my-reconcilers/${identifier}/mark-favourite`,
      reconcilers_unmark_fav: ({ identifier }) =>
        `/my-reconcilers/${identifier}/remove-favourite`,

      // process_of_reconcilers:({identifier})=>`/my-reconcilers/${identifier}/reconciliationrules`,
      // overview:()=>`/my-reconciliationrules/overview`,
      group_overview: ({ identifier }) =>
        `/my-reconcilers/${identifier}/overview`,
      // recon_rule: () => `/my-reconciliationrules`,
      // list_source_by_service:({identifier})=>`/service-sources/${identifier}`,
      // recon_rule_detail: ({ identifier }) => `/my-reconciliationrules/${identifier}`,
      // recon_rule_detaildash:({identifier})=>`/my-reconciliationrules/${identifier}/dashboard`,

      manual_reconciled: ({ identifier }) =>
        `/my-reconcilers/${identifier}/reconciled-transactions`,
      manual_pending: ({ identifier }) =>
        `/my-reconcilers/${identifier}/pending-transactions`,
      approve_manually: ({ identifier }) =>
        `/my-reconcilers/${identifier}/approve`,
      reject_manually: ({ identifier }) =>
        `/my-reconcilers/${identifier}/reject`,

      // reconciled_pending_list: ({ identifier }) => `/my-reconciliationrules/${identifier}/pending-transactions`,

      our_manual_unreconciled: ({ identifier }) =>
        `/my-reconcilers/${identifier}/unreconciled-our-transactions`,
      their_manual_unreconciled: ({ identifier }) =>
        `/my-reconcilers/${identifier}/unreconciled-their-transactions`,
      grouped_unreconciled: ({ params: { source_id, reconciler_id } }) =>
        `/sources/${source_id}/reconcilers/${reconciler_id}/duplicates`,

      recommended_for_rules: ({ params: { rule_id, tran_id } }) =>
        `/my-reconciliationrules/${rule_id}/scored-transactions/${tran_id}`,
      // recommended_for_theirs: ({
      //     params: {
      //         rule_id,
      //         tran_id
      //     }
      // }) => `/my-reconciliationrules/${rule_id}/scored-transactions/${tran_id}`,

      recommended_for_unclassified: ({ params: { reconciler_id, tran_id } }) =>
        `/my-reconcilers/${reconciler_id}/scored-transactions/${tran_id}`,

      // our_tabular_reconciler:({identifier})=>`/my-reconciliationrules/${identifier}/tabular-scored-transactions`,

      reconcile_manually: ({ identifier }) =>
        `/my-reconcilers/${identifier}/manual-reconciliation`,
      reconcile_all_manually: ({ params: { reconciler_id, source_id } }) =>
        `/sources/${source_id}/reconcilers/${reconciler_id}/manual-multi-reconciliation`,

      // reaconcile_tabular:({identifier})=>`/my-reconciliationrules/${identifier}/manual-reconciliation-tabular`,

      aging_filtered_transaction: ({ identifier }) =>
        `/my-reconcilers/${identifier}/unreconciled-txns`,

      split_unreconciled: () => `/unreconciled_transaction_split`,
    },
  },
  myTask: {
    url: {
      todo: () => `/my-tasks/todos`,
      todo_detail: ({ identifier }) => `/my-tasks/todos/${identifier}`,
      todo_done: ({ identifier }) => `/my-tasks/todos/${identifier}/mark-done`,
      followups: () => `/my-tasks/follow-ups`,
      followups_done: ({ identifier }) =>
        `/my-tasks/follow-ups/${identifier}/mark-done`,
    },
  },
  datatype: {
    url: {
      data_types: () => `/data-types`,
      data_types_detail: ({ identifier }) => `/data-types/${identifier}`,
      mirror_to: ({ identifier }) =>
        `/data-types/${identifier}/mirror-to-group`,

      datatype_classifiers: ({ identifier }) =>
        `/data-types/${identifier}/classifiers`,
      datatype_classifiers_detail: ({
        params: { datatype_id, classifier_id },
      }) => `/data-types/${datatype_id}/classifiers/${classifier_id}`,

      service_extractors: ({ identifier }) =>
        `/services/${identifier}/extractors`,
      service_extractors_detail: ({ params: { service_id, extractor_id } }) =>
        `/services/${service_id}/extractors/${extractor_id}`,

      service_enrichers: ({ identifier }) =>
        `/services/${identifier}/enrichers`,
      service_enrichers_detail: ({ params: { service_id, enricher_id } }) =>
        `/services/${service_id}/enrichers/${enricher_id}`,

      pipeline_list: ({ identifier }) => `/data-types/${identifier}/pipelines`,
      pipeline_detail: ({ params: { datatype_id, pipeline_id } }) =>
        `/data-types/${datatype_id}/pipelines/${pipeline_id}`,
      balance_list: ({ identifier }) =>
        `/data-types/${identifier}/opening-balances`,
      balance_detail: ({ params: { datatype_id, balance_id } }) =>
        `/data-types/${datatype_id}/opening-balances/${balance_id}`,
      pipeline_classifiers: ({ identifier }) =>
        `/pipelines/${identifier}/classifiers`,
      pipeline_classifiers_detail: ({
        params: { pipeline_id, classifier_id },
      }) => `/pipelines/${pipeline_id}/classifiers/${classifier_id}`,
      classifier_extractors: ({ identifier }) =>
        `/pipeline-classifiers/${identifier}/extractors`,
      classifier_extractors_detail: ({
        params: { classifier_id, extractor_id },
      }) => `/pipeline-classifiers/${classifier_id}/extractors/${extractor_id}`,
      services_list: ({ identifier }) => `/data-types/${identifier}/services`,
      services_detail: ({ params: { datatype_id, service_id } }) =>
        `/data-types/${datatype_id}/services/${service_id}`,

      flag_list: ({ identifier }) => `/data-types/${identifier}/flags`,
      flag_detail: ({ params: { datatype_id, flag_id } }) =>
        `/data-types/${datatype_id}/flags/${flag_id}`,

      transaction_actions: ({ identifier }) =>
        `/data-types/${identifier}/transaction-actions`,
      transaction_actions_detail: ({ params: { datatype_id, action_id } }) =>
        `/data-types/${datatype_id}/transaction-actions/${action_id}`,

      upload: ({ identifier }) => `/data-types/${identifier}/upload`,
    },
  },
  source: {
    url: {
      list: () => "/sources",
      detail: ({ identifier }) => `/sources/${identifier}`,
      unlabeled_sources: () => `/unlabelled-sources`,
      assign_label: ({ identifier }) => `/sources/${identifier}/assign-label`,
    },
  },

  datarepository: {
    url: {
      list: () => `/data-repositories`,
      detail: ({ identifier }) => `/data-repositories/${identifier}`,
      selectors: ({ identifier }) =>
        `/data-repositories/${identifier}/selectors`,
      selectors_detail: ({ params: { repository_id, selector_id } }) =>
        `/data-repositories/${repository_id}/selectors/${selector_id}`,
    },
  },
  makerchecker: {
    url: {
      listSettings: () => `/maker-checker`,
      toggle: ({ identifier }) => `/maker-checker/${identifier}/toggle-status`,
      enable: ({ identifier }) => `/maker-checker/${identifier}/enable`,
      disable: ({ identifier }) => `/maker-checker/${identifier}/disable`,
      list: () => `/maker-checker/requests`,
      accept: ({ identifier }) =>
        `/maker-checker/requests/${identifier}/accept`,
      delete: ({ identifier }) =>
        `/maker-checker/requests/${identifier}/delete`,
      reject: ({ identifier }) =>
        `/maker-checker/requests/${identifier}/reject`,
      params: ({ identifier }) =>
        `/maker-checker/requests/${identifier}/params`,
    },
  },
  plugins: {
    url: {
      parsers: () => `/parsers`,
      selector_config: () => `/selectors`,
      smart_actions: () => `/smart-actions`,
      cron_jobs: () => `/cron-jobs`,
      hooks:()=>`/hook-plugin-list`,
      unreconciled_actions: () => `/unreconciled-actions`,
      report_plugin_detail: ({ identifier }) =>
        `/report-plugins/${identifier}/meta`,
      transaction_actions: () => `/transaction-actions`,
    },
  },
  profile: {
    url: {
      change_password: () => `/me/profile/change-password`,
      logout: () => `/logout`,
    },
  },
  logs: {
    url: {
      general_logs: () => `/general-logs`,
      user_logs: () => `/user-logs`,
      engine_logs: () => `/engine-logs`,
      cron_logs: () => `/cron-logs`,
    },
  },
  cron: {
    url: {
      list: () => `/cron-configs`,
      detail: ({ identifier }) => `/cron-configs/${identifier}`,
    },
  },
  hook: {
    url: {
      list: () => `/hooks`,
      detail: ({ identifier }) => `/hooks/${identifier}`,
    },
  },
  users: {
    url: {
      user_list: () => `/users`,
      user_detail: ({ identifier }) => `/users/${identifier}`,
      user_revoke: ({ identifier }) => `/users/${identifier}/revoke`,
      enable_user: ({ identifier }) => `/users/${identifier}/enable`,
      disable_user: ({ identifier }) => `/users/${identifier}/disable`,
      change_password: ({ identifier }) =>
        `/users/${identifier}/reset-password`,
      user_hierarchy: ({}) => `/user-hierarchy`,
      user_hierarchy_detail: ({ identifier }) =>
        `/user-hierarchy/${identifier}`,

      user_roles: () => `/roles`,

      assigned_repository: ({ identifier }) =>
        `/users/${identifier}/assigned-repositories`,
      assigned_repository_detail: ({ params: { user_id, data_id } }) =>
        `/users/${user_id}/assigned-repositories/${data_id}`,

      unassigned_repository: ({ identifier }) =>
        `/users/${identifier}/unassigned-repositories`,

      assigned_datatypes: ({ identifier }) =>
        `/users/${identifier}/assigned-data-types`,
      assigned_datatypes_detail: ({ params: { user_id, data_id } }) =>
        `/users/${user_id}/assigned-data-types/${data_id}`,

      unassigned_datatypes: ({ identifier }) =>
        `/users/${identifier}/unassigned-data-types`,

      assigned_reconciliationrules: ({ identifier }) =>
        `/users/${identifier}/assigned-reconcilers`,
      assigned_reconciliationrules_detail: ({ params: { user_id, data_id } }) =>
        `/users/${user_id}/assigned-reconcilers/${data_id}`,

      unassigned_reconciliationrules: ({ identifier }) =>
        `/users/${identifier}/unassigned-reconcilers`,

      assigned_groups: ({ identifier }) =>
        `/users/${identifier}/assigned-groups`,
      assigned_groups_detail: ({ params: { user_id, data_id } }) =>
        `/users/${user_id}/assigned-groups/${data_id}`,

      unassigned_groups: ({ identifier }) =>
        `/users/${identifier}/unassigned-groups`,

      assigned_tables: ({ identifier }) =>
        `/users/${identifier}/assigned-tables`,
      assigned_tables_detail: ({ params: { user_id, data_id } }) =>
        `/users/${user_id}/assigned-tables/${data_id}`,

      unassigned_tables: ({ identifier }) =>
        `/users/${identifier}/unassigned-tables`,
    },
  },

  settings: {
    // cache_for_seconds:1000,
    url: {
      sources: () => `/sources`,
      sources_detail: ({ identifier }) => `/sources/${identifier}`,
      // source_fetchers: ({ identifier }) => `/sources/${identifier}/fetcher-configs`,
      // source_fetchers_detail: ({
      //     params: {
      //         source_id,
      //         config_id
      //     }
      // }) => `/sources/${source_id}/fetcher-configs/${config_id}`,

      // source_service_rules: ({ identifier }) => `/sources/${identifier}/servicerules`,
      // source_service_rules_detail: ({
      //     params: {
      //         source_id,
      //         rule_id
      //     }
      // }) => `/sources/${source_id}/servicerules/${rule_id}`,
      // servicerule_extractors: () => `/servicerule-extractors`,
      // servicerule_extractors_detail: ({ identifier }) => `/servicerule-extractors/${identifier}`,

      // services: () => `/services`,
      // services_detail: ({ identifier }) => `/services/${identifier}`,

      tables: () => `/tables`,
      tables_detail: ({ identifier }) => `/tables/${identifier}`,

      // servicerules: ({ identifier }) => `/sources/${identifier}/services`,
      // comparators:({})=>`/reconciler-comparators`,

      reconciler_group: () => `/reconcilers`,
      reconciler_group_detail: ({ identifier }) => `/reconcilers/${identifier}`,
      move_reconciler: ({ identifier }) =>
        `reconcilers/${identifier}/move-to-group`,
      reconciler_rules: ({ identifier }) =>
        `/reconcilers/${identifier}/reconciliationrules`,
      reconciler_types: () => `/reconciler-types`,
      reconciler_types_detail: ({ identifier }) =>
        `/reconciler-types/${identifier}`,

      reconciler_rules_detail: ({ params: { group_id, recon_id } }) =>
        `/reconcilers/${group_id}/reconciliationrules/${recon_id}`,
      recon_rules_for_exclusion: ({ identifier }) =>
        `/reconcilers/${identifier}/exclusion-group-list`,

      exclusion_list: ({ identifier }) =>
        `/reconcilers/${identifier}/exclusions`,
      exclusion_detail: ({ params: { rule_id, exclusion_id } }) =>
        `/reconcilers/${rule_id}/exclusions/${exclusion_id}`,

      parsers: () => `/parsers`,
      parsers_detail: ({ identifier }) => `/parsers/${identifier}`,

      fetchers: () => `/fetchers`,

      // fetchers_configs: () => `/fetcher-configs`,
      // fetchers_configs_detail: ({ identifier }) => `/fetcher-configs/${identifier}`,

      enrichers: () => `/enrichers`,
      // enrichers_detail: ({ identifier }) => `/enrichers/${identifier}`,
      batchers: () => `/batchers`,
      // batchers_detail: ({ identifier }) => `/batchers/${identifier}`,
      aggregators: () => `/aggregators`,
      aggregators_detail: ({ identifier }) => `/aggregators/${identifier}`,

      eval_plugins: ({}) => `/eval-functions`,
      eval_variables: () => `/eval-variables`,

      report_plugins: () => `/report-plugins`,
      report_actions: () => `/report-actions`,
      datasource: () => `/data-sources`,
      dashboard_widgets: () => `/dashboard-widgets`,
      dashboard_tabs: () => `/dashboard-tabs`,

      reconciler_comparators: () => `/reconciler-comparators`,
      reconciler_comparators_detail: ({ identifier }) =>
        `/reconciler-comparators/${identifier}`,
      extensions: () => `/supported-extensions`,

      smart_actions: () => `/reconciliationrule-smart-actions`,
      smart_actions_detail: ({ identifier }) =>
        `/reconciliationrule-smart-actions/${identifier}`,

      unrecon_smart_actions: () => `/reconciliationrule-unreconciled-actions`,
      unrecon_smart_actions_detail: ({ identifier }) =>
        `/reconciliationrule-unreconciled-actions/${identifier}`,
      smart_actions_plugin: () => `/smart-actions`,

      import: () => `/import-app-config`,
      export: () => `/export-app-config`,
      add_to_datatype: () => `/sources/add-to-datatype`,
      reprocess_repository: () => `/repository/response_reprocess`,
      clean_repository: () => `/repository/clean`
    },
  },
  references: {
    url: {
      list: () => `/config-references`,
      detail: ({ identifier }) => `/config-references/${identifier}`,
    },
  },

  menu: {
    // url used for searchable  menus
    url: {},
  },
  dynamic: {
    // urls used for dynamic selection
    url: {},
  },
  appSetting: {
    url: {
      hierarchy_assigner: () => `/action-hierarchies`,
      basic_setting: () => `/app-setting`,
      password_setting: () => `/settings/password`,
    },
  },
  noAuth: {
    cache_for_seconds: 2 * 24 * 60 * 60,
    url: {
      bank_info: () => `/app-setting`,
    },
  },
  system: {
    url: {
      license_info: () => `/users/license_info`,
    },
  },
  store: {
    url: {
      list_store: () => `/my-dashboards/store-list`,
      list_store_files: () => `/my-dashboards/file_counts`,
    },
  },

  allData: {
    url: {
      overview: () => `/my-data-types/overview`,
      service_overview: ({ identifier }) =>
        `/my-data-types/overview/${identifier}/services`,
      datatypes: () => `/my-data-types`,
      datatypes_details: ({ identifier }) => `/my-data-types/${identifier}`,
      datatype_mark_fav: ({ identifier }) =>
        `/my-data-types/${identifier}/mark-favourite`,
      datatype_unmark_fav: ({ identifier }) =>
        `/my-data-types/${identifier}/remove-favourite`,

      datatype_services: ({ identifier }) =>
        `/my-data-types/${identifier}/services`,
      // datatype_sources:({identifier})=>`/my-data-types/${identifier}/sources`,
      datatype_actions: ({ identifier }) =>
        `/my-data-types/${identifier}/transaction-actions`,
      flag_list: ({ identifier }) => `/my-data-types/${identifier}/flags`,
      // datatype_pipelines:({identifier})=>`/my-data-types/${identifier}/pipelines`,
      transactions: ({ params: { datatype } }) =>
        `/my-data-types/${datatype}/transactions`,
      // transactions: () => `/my-data-types/${"1"}/transactions`,
      unclassified_transaction: ({ params: { datatype } }) =>
        `/my-data-types/${datatype}/transactions?uncategorized=true`,
      // unclassified_transaction:()=>`/transactions`,//?uncategorized=true`,
      classify_service: () => `/transactions/manual-service-classification`,
      transactiondetail: ({ identifier }) => `/transactions/${identifier}`,
      flag_transaction: ({ identifier }) => `/transactions/${identifier}/flag`,
      remove_reconciler: ({ params: { txn_id, reconciler_id } }) =>
        `/transactions/${txn_id}/remove-from-reconciler/${reconciler_id}`,
      remove_all_reconciler: ({ identifier }) =>
        `/transactions/${identifier}/remove-all-reconcilers`,
      add_reconciler: ({ params: { txn_id, reconciler_id } }) =>
        `/transactions/${txn_id}/add-to-reconciler/${reconciler_id}`,
      action_transaction: ({ params: { txn_id, action_id } }) =>
        `/transactions/${txn_id}/apply-txn-action/${action_id}`,
      // reprocess:({identifier})=>`/transactions/${identifier}/reprocess`,
      assign_service: ({ identifier }) =>
        `/transactions/${identifier}/assign-service`,
      // recommended_transaction:({params:{rule_id,transaction_id}})=>`/my-reconciliationrules/${rule_id}/scored-transactions/${transaction_id}`,

      comments: ({ identifier }) => `/transactions/${identifier}/logs`,
      repository_list: ({ identifier }) =>
        `/my-data-types/${identifier}/data-repositories`,
      fetcher_logs: ({ identifier }) =>
        `/data-repositories/${identifier}/execution-logs`,
      responses: ({ identifier }) =>
        `/fetcher-execution-logs/${identifier}/responses`,
      run_fetcher: ({ identifier }) => `/data-repositories/${identifier}/run`,
      source_upload: ({ identifier }) =>
        `/data-repositories/${identifier}/upload`,
      batched_peers: ({}) => `/batch-peers`,
      download_responses: ({ identifier }) =>
        `/fetcher-responses/${identifier}/download`,
      rerun_responses: ({ identifier }) =>
        `/fetcher-responses/${identifier}/reprocess`,
      response_selectors: ({ identifier }) =>
        `/fetcher-responses/${identifier}/selectors`,
    },
  },
};

export { basicDomains, networkDomains };
